import * as React from "react";
import {
  FixedSizeList as List,
  areEqual,
  ListChildComponentProps,
} from "react-window";
import SelectedSite from "./SelectedSite";

interface Props {
  sites: {
    [key: string]: Insite.Site;
  };
  selectedSites: Set<string>;
  handleClick(site: Insite.Site): () => void;
}

interface RowProps extends ListChildComponentProps {
  data: {
    sites: Props["sites"];
    handleClick: Props["handleClick"];
    selected: string[];
  };
}

const Row = React.memo<RowProps>(({ index, data, style }) => {
  const { selected, sites, handleClick } = data;
  const site = sites[selected[index]];

  return (
    <div style={style}>
      <SelectedSite onClick={handleClick(site)} label={site.label} />
    </div>
  );
}, areEqual);

export const SelectedSites: React.FC<Props> = ({
  sites,
  selectedSites,
  handleClick,
}) => {
  const selected = Array.from(selectedSites);

  return (
    <List
      height={295}
      width="100%"
      itemCount={selected.length}
      itemData={{
        selected,
        sites,
        handleClick,
      }}
      itemSize={32}
    >
      {Row}
    </List>
  );
};
